import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const LedgerViewPage: React.FC = () => (
  <PlaceholderPage
    title="应收应付视图"
    summary="对账表总览（A–X 列视图 / 导出）将在后续任务落地。"
    designSection="对账表 / kac-003"
  />
);

export default LedgerViewPage;
